export var AnimateStepType;

!function(AnimateStepType) {
    AnimateStepType.wait = "wait", AnimateStepType.from = "from", AnimateStepType.to = "to", 
    AnimateStepType.customAnimate = "customAnimate";
}(AnimateStepType || (AnimateStepType = {}));

export var AnimateStatus;

!function(AnimateStatus) {
    AnimateStatus[AnimateStatus.INITIAL = 0] = "INITIAL", AnimateStatus[AnimateStatus.RUNNING = 1] = "RUNNING", 
    AnimateStatus[AnimateStatus.PAUSED = 2] = "PAUSED", AnimateStatus[AnimateStatus.END = 3] = "END";
}(AnimateStatus || (AnimateStatus = {}));
//# sourceMappingURL=type.js.map
